import Vue from 'vue';
import { gsap, Power4 } from 'gsap/all';
import state from "../state";

Vue.component('navigation-component', {
    data() {
        return {
            appState: state,
            inTransition: false
        };
    },

    mounted() {
        this.$root.$on('navigation:toggle', this.toggle);
    },

    methods: {
        /**
         * Toggle navigation 
         *
         * @param  {Event} event
         * @return {Void}
         */
        toggle() {
            if (this.inTransition) {
                return;
            }

            this.appState.showNavigation = !this.appState.showNavigation;

            this.inTransition = true;

            const onComplete = () => {
                this.inTransition = false;
            };

            const onReverseComplete = () => {
                this.inTransition = false;
                gsap.set(['.navigation-container', '.navigation-holder', '.navigation-curtain', '.main-navigation__link', '.secondairy-navigation .title-bar', '.secondairy-navigation__link', '.third-navigation__list', '.navigation-container__sub-navigation'], { clearProps: "all" });
            };

            if (document.body.classList.contains('menu-open')) {
                // Closing the menu
                document.body.classList.remove('menu-open');

                gsap.to('.navigation-holder', { duration: 0.8, autoAlpha: 1, ease: Power4.easeOut });
                gsap.to('.navigation-container__sub-navigation', { duration: 0.8, autoAlpha: 0, ease: Power4.easeOut });
                gsap.set('.navigation-container', { overflow: 'hidden' });
                // gsap.to('.header__hamburger-line--1', { duration: 0.8, width: '100%', rotate: '0deg', top: '0px', ease: Power4.easeOut });
                // gsap.to('.header__hamburger-line--2', { duration: 0.8, width: '100%', rotate: '0deg', top: '14px', ease: Power4.easeOut });
                gsap.to(['.header__hamburger-line--1', '.header__hamburger-line--2'], { duration: 0.4, delay: 0.2, opacity: 1, scaleX: 1, ease: Power4.easeOut });
                gsap.to('.header__hamburger-line--3', { duration: 0.4, rotate: 0, ease: Power4.easeOut });
                gsap.to('.header__hamburger-line--4', { duration: 0.4, rotate: 0, ease: Power4.easeOut });
                gsap.to('.main-navigation__link', { duration: 0.4, y: 40, autoAlpha: 0, ease: Power4.ease, stagger: -0.1 });
                // gsap.to('.navigation-container', { delay: 0.1, duration: 0.8, height: 0, ease: Power4.easeOut, onComplete: onReverseComplete });
                gsap.to('.secondairy-navigation .title-bar', { duration: 0.8, scaleX: 0, ease: Power4.easeOut });
                gsap.to('.secondairy-navigation__link', {  duration: 0.5, x: -50, autoAlpha: 0, ease: Power4.ease, stagger: -0.1 });
                gsap.to('.third-navigation__list', { duration: 0.5, x: -50, autoAlpha: 0, ease: Power4.ease });
                gsap.to('.navigation-curtain', { duration: 0.8, delay: 0.2, scaleY: 0, ease: Power4.easeInOut, onComplete: onReverseComplete });

            } else {
                // Opening the menu
                document.body.classList.add('menu-open');

                document.querySelector(".navigation-container").style.display = 'flex';

                gsap.to('.navigation-curtain', { duration: 0.8, scaleY: 1, ease: Power4.easeOut });
                // gsap.to('.navigation-container', { duration: 0, backgroundColor: '#1D1E21' });
                // gsap.to('.header__hamburger-line--1', { duration: 0.8, width: '28px', rotate: '45deg', top: '5px', ease: Power4.easeOut });
                // gsap.to('.header__hamburger-line--2', { duration: 0.8, width: '28px', rotate: '-45deg', top: '5px', ease: Power4.easeOut });
                // gsap.to('.header__hamburger-line--3', { duration: 0.4, scaleX: 0, ease: Power4.easeOut });
                gsap.to(['.header__hamburger-line--1', '.header__hamburger-line--2'], { duration: 0.4, opacity: 0, scaleX: 0, ease: Power4.easeOut });
                gsap.to('.header__hamburger-line--3', { duration: 0.6, delay: 0.2, rotate: -135, ease: Power4.easeOut });
                gsap.to('.header__hamburger-line--4', { duration: 0.6, delay: 0.2, rotate: 135, ease: Power4.easeOut });
                gsap.to('.main-navigation__link', { delay: 0.1, duration: 0.6, y: '0', autoAlpha: 1, ease: Power4.ease, stagger: 0.1 });
                gsap.to('.secondairy-navigation .title-bar', { delay: 0.5, duration: 0.8, scaleX: 1, ease: Power4.easeOut });
                gsap.to('.secondairy-navigation__link', { delay: 0.5, duration: 0.5, x: '0', autoAlpha: 1, ease: Power4.ease, stagger: 0.1 });
                gsap.to('.third-navigation__list', { delay: 0.8, duration: 0.5, x: '0', autoAlpha: 1, ease: Power4.ease, onComplete: onComplete });
            }
        }
    },

    beforeDestroy() {
        this.$root.$off('navigation:toggle');
    }
});